<template>
  <Layout>
    <section v-if="video">
      <section class="mt-20 px-4">
        <VideoPlayer v-if="video.available" />
        <div v-else class="m-auto max-w-screen-xl">
          <img class="w-full" :src="video.image_url" :alt="video.title" />
        </div>
      </section>

      <VideoInfo :video="video" />
    </section>
  </Layout>
</template>

<script>
import Layout from '@/layouts/HomeLayout'
import VideoPlayer from '@/components/VideoPlayer'
import VideoInfo from '@/components/VideoInfo'
import { mapState } from 'vuex'

export default {
  components: { Layout, VideoPlayer, VideoInfo },

  props: {
    slug: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('videos', ['video']),
  },

  mounted() {
    this.$store.dispatch('videos/fetchContactLink')
    this.$store.dispatch('videos/fetchVideo', this.slug)
  },
}
</script>
